import { VisibilityRule } from "./profileTemplate.model";

export const isFieldVisible = (
  field: any,
  formData: Record<string, any>
): boolean => {
  if (!field.visibleWhen || field.visibleWhen.length === 0) {
    return true;
  }

  return field.visibleWhen.every((rule: VisibilityRule) => {
    const controllingValue = formData[rule.fieldKey];

    // If no selection made yet, keep dependent field hidden
    if (!controllingValue) {
      return false;
    }

    if (rule.operator === "equals") {
      return controllingValue === rule.value;
    }

    if (rule.operator === "notEquals") {
      return controllingValue !== rule.value;
    }

    return true;
  });
};

